module.exports = __webpack_public_path__ + "static/media/midst-of-mist.bdf14ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/midst-of-mist.jpg
// module id = 304
// module chunks = 0